let carregando: Promise<any> = null;

export function carregarMonaco(): Promise<any> {
  const w = window as any;
  if (w.monaco) {
    return Promise.resolve(w.monaco);
  }
  if (carregando) {
    return carregando;
  }
  carregando = new Promise((resolve, reject) => {
    const caminho = new URL('assets/monaco/vs', document.baseURI).href;
    const script = document.createElement('script');
    script.src = caminho + '/loader.js';
    script.onload = () => {
      const amdRequire = w.require;
      amdRequire.config({ paths: { vs: caminho } });
      amdRequire(['vs/editor/editor.main'], () => resolve(w.monaco), (erro: any) => {
        carregando = null;
        reject(erro);
      });
    };
    script.onerror = (erro) => {
      carregando = null;
      reject(erro);
    };
    document.body.appendChild(script);
  });
  return carregando;
}
